import styled from "styled-components";

// Header
export const SchdulerHeader = styled.header`
  &.dark {
    color: #fff;
    border-bottom: 1px solid #2b2b2b;
    a,
    button {
      color: #fff;
      path {
        stroke: #fff;
      }
    }
  }
  z-index: 3;
  height: 70px;
  position: relative;
  color: #000;
  background: transparent;
  padding: 0 20px;
  border-bottom: 1px solid #ccc;
  a,
  button {
    color: #000;
  }
  h1 {
    display: none;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  .info {
    font-size: 24px;
    font-weight: 800;
    display: flex;
    align-items: center;
    gap: 10px;
    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }
  .menus {
    display: flex;
    align-items: center;
    gap: 24px;
    font-size: 20px;
    button {
      background: transparent;
      border: none;
      svg {
        display: block;
        margin: auto;
      }
    }
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;
// --Header

// Scheduler
export const SchedulerPageContainer = styled.div`
  height: 100vh;
  overflow: hidden;
  &.dark {
    background: #111;
    color: #efefef;
    a {
      color: #efefef;
    }
    #schduler_content {
    }
  }
  #schduler_content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    flex-direction: row;
  }
  @media screen and (max-width: 767px) {
    #schduler_content {
      height: 100vh;
      overflow-y: auto;
    }
  }
`;
// --Scheduler

// Calendar
export const CalendarContainer = styled.div`
  width: calc(100% - 500px);
  border-left: 1px solid rgb(204, 204, 204);
  border-right: 1px solid rgb(204, 204, 204);
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  .mainCalendar {
    position: relative;
  }
  &.dark {
    border-left: 1px solid #2b2b2b;
    border-right: 1px solid #2b2b2b;
    .fc {
      .fc-event-time {
        display: none;
      }
      table {
        outline: 1px solid #2b2b2b;
        thead tr th.fc-day {
          border-bottom: 1px solid #2b2b2b;
          background: #533b70;
          &:not(:last-child) {
            border-right: 1px solid #2b2b2b;
          }
        }
        tbody tr td .fc-daygrid-day-top .fc-daygrid-day-number .date .weather {
          color: #efefef;
        }
        table {
          tbody tr td {
            border: 1px solid #2b2b2b;
            &.selected {
              background: #464646;
            }
            &.fc-daygrid-day.fc-day-today {
              background: #533b70;
              &.selected {
                background: #4f455b;
              }
              .fc-daygrid-day-number {
                color: #efefef;
              }
            }
          }
        }
      }
    }
    .searchBtn {
      button {
        background: rgb(72, 72, 72);
        color: rgb(239, 239, 239);
      }
    }
  }
  .searchBtn {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    button {
      border: none;
      background: rgb(239, 239, 239);
      border-radius: 0.25em;
      font-size: 16.5px;
      font-weight: 400;
      line-height: 1.5;
      width: 25px;
      height: 25px;
      vertical-align: middle;
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      margin-right: 10px;
    }
  }

  .fc {
    .fc-event-time {
      display: none;
    }
    .fc-button {
      padding: 0.4em;
      font-size: 0.99em;
    }
    .fc-scrollgrid {
      border: none;
    }
    .fc-header-toolbar {
      position: relative;
      height: 25px;
      .fc-toolbar-chunk {
        &:nth-child(1) {
          margin: auto;
          height: 2em;
        }
        &:last-child {
          display: none;
        }
      }
    }
    table {
      outline: 1px solid #dadce0;
      border-collapse: collapse;
      thead tr {
        th {
          border: none;
          &:not(:last-child) {
            border-right: 1px solid #dadce0;
          }
          &.fc-day {
            padding: 2px 0;
            background: transparent;
            font-size: 12px;
            border-bottom: 1px solid #dadce0;
          }
        }
      }
      tbody tr {
        td {
          border: none;
          font-size: 16px;
          cursor: pointer;
          .fc-daygrid-day-frame {
            height: calc((100vh - 175px) / 6);
          }
          &.fc-day-sun .fc-daygrid-day-number {
            color: #ca0000;
          }
          &.fc-day-sat .fc-daygrid-day-number {
            color: #0074ca;
          }
          &.selected {
            background: #efefef;
            &.fc-day-today {
              background: #e8e6db;
            }
          }
          .fc-daygrid-day-top {
            .fc-daygrid-day-number {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              padding-left: 5px;
              .holiday {
                font-size: 12px;
                display: flex;
                align-items: center;
                font-weight: 600;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                word-break: break-all;
                img {
                  width: 15px;
                  height: 15px;
                  margin-right: 5px;
                }
              }
              .date {
                display: flex;
                align-items: center;
                gap: 1%;

                div {
                  display: flex;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  word-break: break-all;
                }
                span {
                  width: 20px;
                  text-align: right;
                  flex-grow: 1;
                }
              }
            }
          }
          .fc-daygrid-day-events {
            font-size: 15px;
            margin-bottom: 0;
          }
          .fc-daygrid-day-bottom {
            pointer-events: none;
            font-size: 11px;
            .fc-daygrid-more-link {
              float: right;
            }
          }
          .fc-event.complete .fc-event-title {
            text-decoration: line-through;
          }
        }
      }
      table {
        position: relative;
        width: 100%;
        outline: none;
        tbody tr td {
          border: 1px solid #dadce0;
          overflow-y: clip;
          &.fc-day-today {
          }
          &:last-child {
            border-right: 0;
          }
        }
      }
    }
  }
  @media screen and (min-width: 1200px), screen and (min-width: 890px) and (max-width: 1051px) {
    .calendarView-C {
      .fc {
        table tbody tr td .fc-daygrid-day-events {
          position: relative;
          font-size: 13px;
          .fc-daygrid-event-harness {
            position: absolute;
            top: 0;
            .fc-event-title {
              padding: 2px;
            }
            &:nth-child(1) {
              left: 10px;
            }
            &:nth-child(2) {
              left: 50%;
              transform: translateX(-50%);
            }
            &:nth-child(3) {
              right: 10px;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1050px) {
    width: calc(100% - 240px);
    border-right: none;
    .fc table tbody tr td {
      .fc-daygrid-day-top .fc-daygrid-day-number .date .weather {
        display: none;
      }
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    border-left: none;
    padding: 20px 0;
    .searchBtn {
      left: 90px;
      &.active {
        left: 20px;
      }
    }

    .fc {
      .fc-header-toolbar {
        .fc-toolbar-chunk:nth-child(1) {
          line-height: 2.3em;
          .fc-toolbar-title {
            font-size: 1em;
          }
        }
        .fc-toolbar-chunk:last-child {
          margin-right: 20px;
        }
      }
      .fc-button .fc-icon {
        font-size: 10px;
      }
      table {
        tbody tr td .fc-daygrid-day-frame {
          height: calc((100vh - 110px) / 6);
        }
        .fc-event-time,
        .fc-event-title {
          width: auto;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 12px;
        }
        tbody tr td .fc-daygrid-day-top .fc-daygrid-day-number {
          .holiday {
            opacity: 0;
            z-index: -999;
          }
        }
      }
    }
  }
`;
// --Calendar

// SideMenu
export const SideMenuContainer = styled.div`
  width: 240px;
  &.dark {
    .wrap {
      .choiceListArea .choiceList li {
        label:hover {
          background: #2b2b2b;
        }
        .more button {
          color: #efefef;
          &:hover {
            background: #2b2b2b;
          }
        }
      }
    }
  }
  .wrap {
    width: 100%;
    height: calc(100vh - 73px);
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
  @media screen and (max-width: 767px) {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    transition: 0.2s;
    z-index: 4;
    .wrap {
      height: 100vh;
      background: #fff;
      z-index: 50;
      width: 270px;
      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
    &.dark .wrap {
      background: #111;
    }
  }
`;
// --SideMenu

// Calendar MobileMenu
export const MobileMenu = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  display: none;
  &.dark {
    button {
      background: #2c3e50;
      color: #efefef;
      &:first-child {
        background: #bb86fc;
      }
    }
  }
  button {
    border: none;
    background: #efefef;
    border-radius: 0.25em;
    font-size: 16.5px;
    font-weight: 400;
    line-height: 1.5;
    /* padding: 0.4em 0.65em; */
    padding: 0.4em;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    svg {
      display: block;
    }
  }

  @media screen and (max-width: 767px) {
    display: flex;
    z-index: 1;
    button {
      width: 25px;
      height: 25px;
      padding: 0;
    }
  }
`;
// --Calendar MobileMenu

// HamburgerMenu
export const HamburgerMenuContainer = styled.div`
  position: fixed;
  bottom: 60px;
  right: 30px;
  cursor: pointer;
  z-index: 100;
  &.dark {
    .burgerNav {
      .burgerBox {
        background: #533b70;
        &:has(input:checked) {
          background: #2b2b2b;
        }
        .burger {
          input:checked ~ div span:nth-of-type(3),
          input:checked ~ div span:nth-of-type(1) {
            background: #efefef;
          }
        }
      }
      .sidebar .list li div {
        background: #533b70;
        p {
          background: #2b2b2b;
        }
      }
    }
  }
  .bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
  }
  .burgerNav {
    position: relative;
    height: 100%;
    width: 50px;
    height: 50px;
    z-index: 1;
    svg {
      font-size: 30px;
      color: #fff;
      display: block;
    }
    .burgerBox {
      background-color: #0074ca;
      border-radius: 50%;
      z-index: 1;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      height: 100%;
      &:has(input:checked) {
        background: #f0f0f0;
      }
      .burger {
        position: relative;
        width: 100%;
        height: 100%;
        background: transparent;
        cursor: pointer;
        display: block;
        padding: 15px;
        input {
          display: none;
          &:checked {
            & ~ div {
              width: 25px;
              height: 23px;
              span:nth-of-type(1) {
                transform: rotate(45deg);
                top: 1px;
                left: 4px;
                background: #999;
              }
              span:nth-of-type(2) {
                width: 0%;
                opacity: 0;
              }
              span:nth-of-type(3) {
                transform: rotate(-45deg);
                top: 19px;
                left: 4px;
                background: #999;
              }
            }
          }
        }
        div {
          width: 25px;
          height: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          span {
            display: block;
            position: absolute;
            height: 4px;
            width: 100%;
            background: #fff;
            border-radius: 9px;
            opacity: 1;
            left: 0;
            transform: rotate(0deg);
            transition: 0.25s ease-in-out;
            &:nth-of-type(1) {
              top: 0px;
              transform-origin: left center;
            }
            &:nth-of-type(2) {
              top: 50%;
              transform: translateY(-50%);
              transform-origin: left center;
            }
            &:nth-of-type(3) {
              top: 100%;
              transform-origin: left center;
              transform: translateY(-100%);
            }
          }
        }
      }
    }
    .sidebar {
      .list {
        li {
          position: absolute;
          left: 0;
          pointer-events: none;
          z-index: -99;
          transition: 0.25s ease-in-out;
          width: 100%;
          height: 100%;
          &:nth-child(1) {
            bottom: 85px;
          }
          &:nth-child(2) {
            bottom: 170px;
          }
          opacity: 0;
          div {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #0074ca;
            border-radius: 50%;
            width: 100%;
            height: 100%;
            position: relative;
            p {
              position: absolute;
              bottom: -15px;
              left: 0;
              width: 100%;
              background: #999;
              text-align: center;
              border-radius: 5px;
              font-size: 10px;
              color: #fff;
            }
          }
        }
        &.open li {
          pointer-events: auto;
          opacity: 1;
          z-index: 1;
          div {
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            p {
            }
          }
        }
      }
    }
  }
`;

export const DetailEventContainer = styled.div`
  &.dark {
    background: #111;
    color: #eee;
    button {
      color: #eee;
    }
    .comment .box .date {
      background: transparent;
    }
  }
  font-size: 16px;
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    span {
      font-size: 16px;
      font-weight: 700;
    }
    button {
      border: none;
      background: transparent;
      color: #aba9a9;
    }
  }
  .pageInfo {
    width: 100%;
    border-bottom: 1px solid #333;
  }
  .content {
    padding: 20px;
    max-width: 50vw;
    height: calc(100vh - 70px);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    > div.members {
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 5px;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .content {
      max-width: 70vw;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 12px;
    .members {
      ul li,
      .manager {
        img {
          width: 40px;
          height: 40px;
        }
        span:first-child {
          font-size: 14px;
          margin-bottom: 0;
        }
      }
    }
    .content {
      max-width: 100%;
      height: calc(100vh - 50px);
    }
  }
`;

export const EventInfoDetailList = styled.ul`
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  > li {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    gap: 25px;
    &:last-child {
      margin-bottom: 0;
    }
    .tit {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 45px;
      font-weight: 600;
      font-size: 12px;
      svg {
        font-size: 22px;
        stroke-width: 0.5px;
      }
    }
    .content {
      width: calc(100% - 60px);
      font-size: 13px;
      overflow-y: auto;
      word-break: break-all;
      &.place {
        max-height: 36px;
      }
      &.workers {
        max-height: 72px;
        .worker {
          display: inline;
        }
      }
      &.memo {
        ul {
          li {
            display: flex;
            flex-wrap: wrap;
            min-height: 10px;
            gap: 5px;
            margin-bottom: 3px;
            &:last-child {
              margin-bottom: 0;
            }
            label {
              input[type="checkbox"] {
                display: none;
              }
              .checkmark {
                display: block;
                width: 18px;
                height: 18px;
                border: 2px solid #d4d4d4;
                border-radius: 5px;
                background-color: transparent;
                transition: all 0.3s ease;
                position: relative;
                &:after {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%) rotate(45deg) scale(0);
                  opacity: 0;
                  width: 6px;
                  height: 10px;
                  border: solid #fff;
                  border-width: 0px 2px 2px 0px;
                  transition: 0.3s;
                }
              }
              input[type="checkbox"]:checked ~ .checkmark {
                background: #0074ca;
                border: 1px solid #d4d4d4;
                &:after {
                  opacity: 1;
                  transform: translate(-50%, -55%) rotate(45deg) scale(1);
                  border-color: #fff;
                }
              }
              &:hover .checkmark {
                background-color: #efefef;
              }
            }
            > span {
              display: inline-block;
              width: calc(100% - 23px);
            }
            .mentions {
              padding-left: 20px;
              display: flex;
              span {
                width: auto;
                background: rgb(239, 239, 239);
                padding: 1px 5px;
                border-radius: 5px;
                color: #0074ca;
                font-size: 12px;
              }
            }
          }
        }
        &.dDay {
          max-height: 32px;
        }
      }
      &.workers,
      &.place,
      &.memo {
        &::-webkit-scrollbar {
          width: 8px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #0074ca;
          border: 2px solid #fff;
        }
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
      }
    }
  }
`;

export const EventGalleryContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 30px 0 0;
  .dragToUpload {
    height: 30%;
    label {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: 1px dashed #bcdaef;
      border-radius: 0.25em;
      width: 100%;
      height: 100%;
      cursor: pointer;
      svg {
        font-size: 35px;
        margin-bottom: 10px;
        color: #747474;
      }
    }
  }
  .dropImageCollection {
    width: 100%;
    height: 60%;
    .collection {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 25px 15px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      .imgBox {
        width: calc((100% - 3 * 15px) / 4);
        height: calc((100% - (2 * 25px)) / 2.5);
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .delBox {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.1);
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
          button {
            border: none;
            background: transparent;
            color: #fff;
            font-size: 40px;
          }
        }
      }
    }
  }
  .btnArea.gallery {
    justify-content: end;
    button {
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export const SearchEventContainer = styled.div`
  > div {
    height: calc(100vh - 170px);
    overflow-y: auto;
    &.dark {
      table {
        background: transparent;
      }
      table td {
        border: 1px solid #2b2b2b;
      }
      form {
        button {
          background: #533b70;
          color: #efefef;
        }
        input {
          border: none;
          box-shadow: none;
          background: transparent;
          border-bottom: 2px solid #2b2b2b;
          color: #efefef;
          &:focus {
            box-shadow: none;
            border: none !important;
            border-bottom: 2px solid #2b2b2b !important;
          }
        }
      }
      table .event .doc p {
        background: #333;
        span:nth-child(1) {
          color: #eee;
        }
      }
    }
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    form {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 14px;
      margin-bottom: 30px;
      div {
        width: 70%;
        position: relative;
        input {
          border: 1px solid #efefef;
          padding: 10px 30px 10px 10px;
          width: 100%;
        }
        span {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
          cursor: pointer;
          font-size: 20px;
          display: flex;
          align-items: center;
        }
      }
      button {
        border: none;
        background: #efefef;
        padding: 10px;
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      background: #fff;

      td {
        padding: 7px 0;
        border: 1px solid #f5f5f5;
        font-size: 14px;
      }
      .year,
      .month,
      .day {
        text-align: center;
        font-weight: 600;
      }
      .year {
        width: 65px;
      }
      .month,
      .day {
        width: 45px;
      }
      .day {
        cursor: pointer;
      }
      .event {
        cursor: pointer;
        padding: 7px;
        div {
          display: flex;
          justify-content: space-between;
          color: #fff;
          position: relative;
        }
        &.outside {
          background: #0074ca;
          background: linear-gradient(rgb(0, 116, 202), rgb(237, 85, 131));
        }
        .doc {
          p {
            position: absolute;
            top: 20px;
            background: #fff;
            right: 15px;
            width: 200px;
            border-radius: 10px;
            box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
            font-size: 12px;
            opacity: 0;
            transform: scale(0);
            padding: 0;
            transition: 0.3s;
            z-index: 10;
            span {
              display: block;
              &:nth-child(1) {
                color: #333;
              }
              &:nth-child(2) {
                margin-top: 10px;
                color: #999;
              }
            }
          }
          &:hover {
            p {
              opacity: 1;
              transform: scale(1);
              padding: 10px;
            }
          }
        }
      }
    }
    .not {
      text-align: center;
      font-size: 20px;
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 767px) {
    > div {
      height: calc(100vh - 4em - 20px);
      table {
        td {
          font-size: 12px;
        }
        .year {
          width: 50px;
        }
        .month,
        .day {
          width: 40px;
        }
      }
    }
  }
`;

export const CalendarActions = styled.div`
  &.dark {
    .today {
      background: #484848;
      color: #efefef;
    }
  }
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  z-index: 1;
  button {
    height: 25px;
    text-align: center;
    border-radius: 3px;
    vertical-align: middle;
    border: 1px solid transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .today {
    background: #0c41ff;
    color: #fff;
    width: 50px;
  }
  .month {
    margin-left: 10px;
    display: flex;
    button {
      width: 25px;
      background: #f5f5f5;
      color: #6a778b;
      svg {
        stroke-width: 1;
      }
      &:first-child {
        border-radius: 3px 0 0 3px;
      }
      &:last-child {
        border-radius: 0 3px 3px 0;
      }
    }
  }

  @media screen and (max-width: 767px) {
    right: 20px;
  }
`;

export const SideMenuActions = styled.div`
  &.dark {
    button {
      background: rgb(83, 59, 112);
      color: #fff;
    }
  }
  padding: 20px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;
  button {
    width: 100%;
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 5px;
    cursor: pointer;
    border: none;
  }
  @media screen and (max-width: 767px) {
    font-size: 12px;
    flex-wrap: wrap;
    &.dark button {
      background: #2b2b2b;
      &:nth-child(1) {
        background: rgb(187, 134, 252);
      }
    }
    button {
      padding: 10px 0;
      width: calc(50% - 5px);
      &:nth-child(1) {
        width: 100%;
        background: rgb(12, 65, 255);
        color: #fff;
      }
    }
  }
`;

export const SideMenuCalendar = styled.div`
  &.dark {
    .select {
      color: #efefef;
    }
    .calendars {
      border-top: 1px solid #2b2b2b;
      border-bottom: 1px solid #2b2b2b;
      .buttons button {
        background: #2b2b2b;
        color: #efefef;
      }
      .fc {
        table {
          .fc-daygrid-day {
            &.selected .fc-daygrid-day-top {
              background: #464646;
            }
            &.fc-day-today .fc-daygrid-day-top {
              background: #533b70;
            }
            &.selected.fc-day-today .fc-daygrid-day-top {
              background: #4f455b;
            }
          }
        }
      }
      .content div span {
        &.active {
          border-color: rgba(255, 255, 255, 0.2);
        }
        &:hover {
          color: #efefef;
          background: rgba(255, 255, 255, 0.4);
        }
      }
    }
  }
  position: relative;
  .select {
    position: absolute;
    top: 20px;
    z-index: 50;
    border: none;
    background: transparent;
    padding: 5px;
  }
  .calendars {
    position: relative;
    padding: 20px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    max-height: 300px;
    .buttons {
      position: absolute;
      top: 20px;
      right: 20px;
      display: flex;
      button {
        padding: 2px;
        border: 1px solid transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;
        background: #f5f5f5;
        color: #6a778b;
        border-radius: 5px;
        font-size: 10px;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0 5px 5px 0;
        }
        svg {
          display: block;
          stroke-width: 1.5;
          margin: auto;
        }
      }
      .month {
        margin-left: 10px;
        display: flex;
        button {
          font-size: 10px;
          background: #f5f5f5;
          width: 21px;
          color: #6a778b;
          &:first-child {
            border-radius: 5px 0px 0px 5px;
          }
          &:last-child {
            border-radius: 0px 5px 5px 0px;
          }
        }
      }
    }
    .monthsInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      height: 21.91px;
      h2 {
        font-size: 13px;
        cursor: pointer;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      height: 201px;
      font-size: 14px;
      div {
        width: 25%;
        height: 67px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          padding: 5px;
          text-align: center;
          cursor: pointer;
          border-radius: 0.25em;
          transition: 0.3s;
          &:hover {
            background: #0c41ff;
            color: #fff;
          }
          &.active {
            border: 2px solid #dadce0;
          }
        }
      }
    }
    .fc {
      table .fc-daygrid-day-events {
        .fc-daygrid-event-dot {
          background: #efefef;
        }
        .scheduleC .fc-daygrid-event-dot {
          background: #0074ca;
        }
        .scheduleG .fc-daygrid-event-dot {
          background: #f06f02;
        }
        .scheduleO .fc-daygrid-event-dot {
          background: #ed5583;
        }
        .scheduleEM .fc-daygrid-event-dot {
          background: #139859;
        }
        .scheduleGS .fc-daygrid-event-dot {
          background: #ffc455;
        }
        .scheduleBB .fc-daygrid-event-dot {
          background: #8f2d56;
        }
        .scheduleLL .fc-daygrid-event-dot {
          background: #a7a3d9;
        }
        .scheduleTT .fc-daygrid-event-dot {
          background: #38c6bd;
        }
        .scheduleVL .fc-daygrid-event-dot {
          background: #b350c3;
        }
      }
      .fc-header-toolbar {
        .fc-toolbar-chunk:last-child {
          display: none;
        }
      }
      .fc-header-toolbar {
        height: 21.91px;
        .fc-toolbar-title {
          font-size: 13px;
          cursor: pointer;
        }
        .fc-button {
          font-size: 10px;
          padding: 2px;
        }
      }
      table {
        .fc-daygrid-day {
          &.fc-day-today {
            background: none;
            .fc-daygrid-day-top {
              background: #fffadf;
            }
            &.selected {
              .fc-daygrid-day-top {
                background: #e8e6db;
              }
            }
          }
          &.selected {
            .fc-daygrid-day-top {
              background: #efefef;
            }
          }
        }
        border: none;
        tbody tr td,
        thead tr th {
          border: none;
        }
        tbody tr td {
          cursor: pointer;
          .fc-daygrid-event.fc-event-end,
          .fc-daygrid-event.fc-event-start {
            margin: 0;
          }
        }
        .fc-daygrid-day-top {
          justify-content: center;
        }
        .fc-daygrid-day-events {
          min-height: 0;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          height: 10px;
          margin: 0;
          overflow: hidden;
          .fc-event-time,
          .fc-event-title {
            display: none;
          }
          .fc-daygrid-day-bottom {
            margin: 0;
          }
          .fc-daygrid-event-dot {
            border: none;
            width: 5px;
            height: 5px;
            margin: 0px 1px;
          }
          .scheduleP .fc-daygrid-event-dot {
            background: #139859;
          }
          .scheduleC .fc-daygrid-event-dot {
            background: #0074ca;
          }
          .scheduleG .fc-daygrid-event-dot {
            background: #f06f02;
          }
          .scheduleO .fc-daygrid-event-dot {
            background: #ed5583;
          }
        }
      }
    }
  }
`;

export const ChoiceList = styled.div`
  font-size: 14px;
  &.dark {
    > div {
      :nth-child(2) {
        border-top: 1px solid #2b2b2b;
        border-bottom: 1px solid #2b2b2b;
      }
    }
    ul > li {
      .more button {
        color: #efefef;
      }
      label:hover,
      .more button:hover {
        background: #2b2b2b;
      }
    }
  }
  .label {
    margin: 10px 0;
    padding: 20px 20px 0 20px;
    font-size: 20px;
    font-weight: 700;
  }
  > div {
    :nth-child(2) {
      border-top: 1px solid #efefef;
      border-bottom: 1px solid #efefef;
    }
  }
  .complete {
    .tab {
      width: calc(100% / 3);
    }
    input[id="completeYn-D"]:checked ~ .glider {
      transform: translateX(5%);
    }
    input[id="completeYn-Y"]:checked ~ .glider {
      transform: translateX(125%);
    }
    input[id="completeYn-N"]:checked ~ .glider {
      transform: translateX(240%);
    }
    .glider {
      width: 50px;
    }
  }
  .calendarView,
  .excludeUnrelated {
    .tab {
      width: calc(100% / 2);
    }
    input[id="viewMode-D"]:checked ~ .glider,
    input[id="excludeUnrelated-Y"]:checked ~ .glider {
      transform: translateX(0%);
    }
    input[id="viewMode-C"]:checked ~ .glider,
    input[id="excludeUnrelated-N"]:checked ~ .glider {
      transform: translateX(100%);
    }
    .glider {
      width: calc(50% - 10px);
    }
  }
  ul {
    > li {
      label {
        display: block;
        width: 100%;
        padding: 5px 20px;
        cursor: pointer;
        &:hover {
          background: #efefef;
        }
        input[type="checkbox"] {
          margin-right: 5px;
        }
      }
      &.personalYn {
        input[type="checkbox"] {
          accent-color: #139859;
        }
      }
      &.companyYnList {
        input[type="checkbox"] {
          accent-color: #0074ca;
        }
      }
      &.groupYnList {
        input[type="checkbox"] {
          accent-color: #f06f02;
        }
      }
      .more {
        button {
          border: none;
          background-color: transparent;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #333;
          padding: 5px 20px;
          width: 100%;
          span {
            font-size: 10px;
            svg {
              display: block;
              margin-left: 7px;
            }
          }
          &:hover {
            background: #efefef;
          }
        }
        ul {
          max-height: 0;
          transition: 0.2s;
          overflow: hidden;
          li {
            label {
              padding-left: 40px;
              cursor: pointer;
            }
          }
          &.active {
            max-height: 100vh;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .complete input[id="completeYn-D"]:checked ~ .glider {
      transform: translateX(20%);
    }
    .complete input[id="completeYn-Y"]:checked ~ .glider {
      transform: translateX(155%);
    }
    .complete input[id="completeYn-N"]:checked ~ .glider {
      transform: translateX(290%);
    }
  }
`;

export const SwitchContainer = styled.div`
  &.dark {
    .tabs {
      background: #2b2b2b;
      border: 1px solid #2b2b2b;
    }
    .glider {
      background: #000;
    }
  }
  padding: 0 20px 20px;
  width: 100%;
  .tabs {
    display: flex;
    position: relative;
    background-color: #fff;
    border: 1px solid #efefef;
    padding: 5px 10px;
    border-radius: 20px;
    width: 100%;
  }
  .tabs * {
    z-index: 2;
  }
  input[type="radio"] {
    display: none;
  }
  .tab {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    font-size: 0.8rem;
    font-weight: 500;
    border-radius: 99px;
    cursor: pointer;
    transition: color 0.15s ease-in;
  }
  .glider {
    position: absolute;
    display: flex;
    height: 30px;
    background-color: #e6eef9;
    z-index: 1;
    border-radius: 10px;
    transition: 0.25s ease-out;
  }
`;

export const DdayModalContainer = styled.div`
  width: 250px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  letter-spacing: -1px;
  .date {
    font-size: 24px;
    font-weight: 900;
  }
  .title {
    margin: 5px 0 20px;
  }
  .memo {
    font-size: 14px;
    width: 100%;
    height: 80px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 10px;
    white-space: pre-line;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
`;

export const ContextMenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  font-size: 12px;
  div {
    width: 80px;
    position: absolute;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    border-radius: 5px;
    border: 1px solid #ccc;
    button {
      text-align: left;
      width: 100%;
      padding: 5px;
      border: none;
      background: transparent;
      display: block;
      transition: 0.3s;
      &:first-child {
        border-bottom: 1px solid #ccc;
      }
      &:hover {
        background: #efefef;
      }
    }
  }
`;

export const EventCommentsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h3 {
    width: calc(100% - 85px);
    position: relative;
    margin-bottom: 5px;
    font-size: 19px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    strong {
      font-size: 14px;
      display: inline-block;
      margin-left: 5px;
      color: #999;
    }
  }
  > ul {
    height: calc(100% - 100px);
    overflow: auto;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    > li {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
      }
      .dropdown {
        width: 30px;
        font-size: 18px;
        position: relative;
        cursor: pointer;
        svg {
          display: block;
          margin: auto;
        }
        ul {
          z-index: 10;
          position: absolute;
          right: 0;
          top: 100%;
          border: 1px solid #ddd;
          background: #fff;
          box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
          li {
            width: 50px;
            height: 20px;
            text-align: center;
            font-size: 14px;
            color: #000;
            &:nth-child(2) {
              border-top: 1px solid #ddd;
            }
          }
        }
      }
      .comment {
        width: calc(100% - 80px);
        span {
          color: #333;
          font-size: 12px;
          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }
  .form {
    width: 100%;
    height: 30px;
    position: relative;
    input {
      width: calc(100% - 30px);
      height: 30px;
      padding: 0 30px 0 10px;
      border: 1px solid #999;
      &:focus {
        box-shadow: none;
        border: 1px solid #999 !important;
      }
    }
    button.reset {
      border: none;
      background: transparent;
      position: absolute;
      right: 40px;
      top: 50%;
      transform: translateY(-50%);
      svg {
        display: block;
        margin: auto;
      }
    }
    button.submit {
      width: 30px;
      height: 30px;
      background: #999;
      border: 1px solid #999;
      color: #fff;
      svg {
        display: block;
        margin: auto;
      }
    }
  }
`;

export const CommentContainer = styled.div`
  flex-grow: 1;
  min-height: 0;
  &.dark {
    .box .date {
      background-color: #000;
      span {
        background: #333;
        color: #fff;
      }
    }
    .box > ul > li .dropdown button {
      color: #eee;
    }
    .box > ul > li .dropdown ul {
      background: #222;
      border: none;
    }
    .box > ul > li .dropdown ul {
      overflow: hidden;
      li:hover {
        background: #555;
      }
    }
  }
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .box {
    height: calc(100% - 55px);
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    .date {
      text-align: right;
      position: sticky;
      font-size: small;
      top: 0;
      padding: 0 5px 5px;
      background: #fff;
      margin-top: 5px;
      &:first-child {
        margin-top: 0;
      }
      span {
        display: inline-block;
        padding: 2px 7px;
        background: #efefef;
        border-radius: 10px;
      }
    }
  }
  .box > ul > li {
    &.copy {
      img {
        filter: grayscale(100%);
      }
    }
    &.not {
      width: 100%;
      height: 100%;
      justify-content: center;
      color: #aba9a9;
    }
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    position: relative;
    &:last-child {
      margin-bottom: 0;
    }
    .comment {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px 5px;
      width: calc(100% - 85px);
      span {
        &:first-child {
          font-size: 15px;
          font-weight: 700;
        }
        &:nth-child(2) {
          font-size: 12px;
          color: #aba9a9;
        }
      }
      p {
        width: 100%;
        color: #777;
        img {
          width: 15px;
          height: 15px;
          object-fit: contain;
          margin-right: 5px;
          cursor: pointer;
          border-radius: 0;
        }
      }
    }
    .dropdown {
      button {
        width: 25px;
        height: 25px;
        font-size: 24px;
        border: none;
        background: transparent;
        svg {
          display: block;
          margin: 0;
        }
      }
      ul {
        position: absolute;
        top: 100%;
        right: 0px;
        z-index: 10;
        width: 70px;
        background: rgb(255, 255, 255);
        box-shadow: rgba(0, 0, 0, 0.15) 0px 6px 12px -2px, rgba(0, 0, 0, 0.1) 0px 3px 7px -3px;
        border-radius: 5px;
        border: 1px solid #ccc;
        li {
          padding: 5px 0;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            background: #efefef;
          }
          &:first-child {
            border-bottom: 1px solid #ccc;
          }
        }
      }
    }
  }

  .form {
    display: flex;
    position: relative;
    margin-top: 20px;
    input {
      border: 1px solid #e9e9e9;
      border-radius: 3px;
      width: calc(100% - 35px);
      padding: 0 25px 0 10px;
      &:focus {
        border: 1px solid #e9e9e9 !important;
        background: #efefef;
        box-shadow: none;
      }
    }
    .reset {
      position: absolute;
      top: 50%;
      right: 35px;
      transform: translate(-50%, -50%);
      border: none;
      background: transparent;
      color: #999;
      svg {
        display: block;
        margin: auto;
      }
    }
    .submit {
      width: 35px;
      height: 35px;
      font-size: 20px;
      border: none;
      background: transparent;
      svg {
        display: block;
        margin-left: auto;
      }
    }
  }
  &.dark {
    .form {
      input {
        border: 1px solid #484848;
        background: #484848;
        color: #efefef;
        &:focus {
          border: 1px solid #484848 !important;
        }
      }
      button {
        color: #efefef;
      }
    }
    > ul > li {
      .comment p {
        color: #fff;
      }
      button {
        color: #fff;
      }
    }
    > ul > li .dropdown ul {
      border: 1px solid #333;
      background: #484848;
      li {
        &:first-child {
          border-bottom: 1px solid #333;
        }
        &:hover {
          background: #333;
        }
      }
    }
  }
`;

export const EventContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  &.d-day {
    .content {
      height: 300px;
    }
  }
  &.schedule {
    .content {
      height: 600px;
    }
  }
  .content {
    z-index: 10;
    background: #fff;
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    width: 430px;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
  }
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    span {
      font-size: 16px;
      font-weight: 700;
    }
    button {
      border: none;
      background: transparent;
      color: #aba9a9;
    }
  }
  &.dark {
    .content {
      background: #000;
    }
  }
`;

export const EventTabContainer = styled.ul`
  &.dark {
    background: #2b2b2b;
    li {
      color: #fff;
    }
  }
  background: #f4f4f4;
  border-radius: 25px;
  display: flex;
  align-items: center;
  margin: auto auto 0 auto;
  justify-content: center;
  width: 244px;
  height: 50px;
  gap: 30px;
  li {
    text-align: center;
    color: #545454;
    cursor: pointer;
    position: relative;
    height: 50px;
    width: 50px;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    &:first-child {
    }
    &:last-child {
      margin-bottom: 0;
    }
    span {
      font-size: 12px;
    }
    svg {
      display: block;
      margin: 0;
      font-size: 20px;
    }
    .dot {
      position: absolute;
      width: 16px;
      height: 16px;
      line-height: 16px;
      font-size: 8px;
      background: #000;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      top: 2px;
      right: 0px;
    }
  }
`;

export const EventInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  button {
    border: none;
    background: transparent;
    font-size: 20px;
    svg {
      display: block;
      margin: 0;
    }
  }
  .actions {
    button {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .context {
    position: absolute;
    top: 45px;
    right: 45px;
    z-index: 10;
    width: 80px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    border-radius: 5px;
    border: 1px solid #ccc;
    overflow: hidden;
    li {
      text-align: center;
      border-bottom: 1px solid #ddd;
      cursor: pointer;
      transition: 0.3s;
      padding: 3px 0;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background: #efefef;
      }
    }
  }
  &.dark {
    button {
      color: #efefef;
    }
    .context {
      background: #484848;
      border: 1px solid #333;
      li {
        border-bottom: 1px solid #333;
        &:last-child {
          border-bottom: none;
        }
        &:hover {
          background: #333;
        }
      }
    }
  }
`;

export const EventTitleContainer = styled.div`
  max-width: calc(100% - 70px);
  &.detail {
    margin-bottom: 30px;
    &.view-4 {
      display: none;
    }
  }
  &.dark {
    &.view-1 ul li:first-child,
    &.view-2 p strong,
    &.view-3 p strong,
    &.view-4 p strong,
    &.view-0 span {
      color: #fff;
    }
  }
  .complete {
    text-decoration: line-through;
  }
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
  &.view-0 {
    .title {
      display: flex;
      align-items: center;
      padding-left: 5px;
      margin-bottom: 5px;
      position: relative;
      &.outside {
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -5px;
          width: 5px;
          height: 100%;
          background: linear-gradient(rgb(0, 116, 202), rgb(237, 85, 131));
          z-index: 2;
        }
      }
      p {
        font-size: 16px;
        font-weight: 700;
      }
    }
    span {
      font-size: 12px;
      color: #202020;
    }
  }
  &.view-1 {
    max-width: calc(100% - 85px);
    display: flex;
    align-items: center;
    gap: 16px;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      position: relative;
    }
    ul {
      max-width: calc(100% - 26px);
      color: #aba9a9;
      li {
        margin-bottom: 5px;
        width: 100%;
        white-space: pre-line;
        &:last-child {
          margin-bottom: 0;
        }
        &:first-child {
          font-size: 16px;
          font-weight: 700;
          color: #000;
        }
        &.title {
          display: flex;
          align-items: flex-start;
          gap: 5px;
          img {
            width: 19px;
            height: 19px;
          }
        }
        &.date {
          display: flex;
          align-items: center;
          gap: 5px;
          i {
            font-size: 20px;
          }
          svg {
            margin: 0;
            display: block;
          }
        }
      }
    }
  }
  &.view-2,
  &.view-3,
  &.view-4 {
    p {
      font-size: 16px;
      font-weight: 700;
      strong {
        color: #202020;
      }
    }
  }
`;

export const DetailBoxContainer = styled.ul`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  li {
    width: calc((100% - 40px) / 3);
    min-height: 130px;
    border-radius: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
    color: #fff;
    i {
      display: block;
      font-size: 50px;
      svg {
        display: block;
        margin: 0;
      }
    }
    strong {
      font-size: 14px;
    }
    &:nth-child(1) {
      background: #6672fc;
    }
    &:nth-child(2) {
      background: #f7b54c;
    }
    &:last-child {
      background: #52b0a7;
      span {
        /* font-size: 12px; */
      }
    }
  }
`;

export const MemoContainer = styled.div`
  margin-bottom: 20px;
  ul {
    height: 120px;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
  li {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 10px;
    min-height: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    > span {
      max-width: calc(100% - 30px);
      word-break: break-all !important;
    }
  }
  .checkedInfo {
    padding-left: 20px;
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    i {
      color: #facc43;
      font-size: 16px;
      svg {
        display: block;
        margin: 0;
      }
    }
    span {
      width: auto;
      color: #707070;
    }
  }
  .mentions {
    padding-left: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    width: 100%;
    span {
      width: auto;
      background: #6e57fe;
      padding: 4px 10px;
      border-radius: 10px;
      color: #eee;
      font-size: 12px;
    }
  }
  label {
    input[type="checkbox"] {
      display: none;
    }
    .checkmark {
      display: block;
      width: 18px;
      height: 18px;
      border: 2px solid #d4d4d4;
      border-radius: 5px;
      background-color: transparent;
      transition: all 0.3s ease;
      position: relative;
      cursor: pointer;
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg) scale(0);
        opacity: 0;
        width: 6px;
        height: 10px;
        border: solid #fff;
        border-width: 0px 2px 2px 0px;
        transition: 0.3s;
      }
    }
    input[type="checkbox"]:checked ~ .checkmark {
      background: #0074ca;
      border: 1px solid #d4d4d4;
      &:after {
        opacity: 1;
        transform: translate(-50%, -55%) rotate(45deg) scale(1);
        border-color: #fff;
      }
    }
    &:hover .checkmark {
      background-color: #efefef;
    }
  }
  &.dark {
    ul {
      border: 1px solid #484848;
    }
    label input[type="checkbox"]:checked ~ .checkmark {
      border: 1px solid #444;
    }
    .checkedInfo span {
      color: #9c9c9c;
    }
    .mentions span {
      background: #252629;
    }
  }
`;

export const ReportContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  .memo {
    flex-grow: 1;
    min-height: 0;
    ul {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
  span.not {
    color: rgb(204, 204, 204);
    margin: 10px 0;
    font-weight: normal;
  }
  .gallery {
    min-height: 48px;
    flex-grow: initial;
    &.notUpload .label ~ .images {
      height: auto;
      li {
        margin-bottom: 0;
      }
    }
  }
  @media screen and (max-width: 767px) {
    span.not {
      font-size: 12px;
    }
  }
`;

export const GalleryContainer = styled.div`
  position: relative;
  flex-grow: 1;
  min-height: 0;
  &.dark {
    .dragToUpload label,
    .images li img {
      border: 1px solid #484848;
    }
    .images li {
      border-color: #333;
    }
    .context {
      border-color: #333;
      background: #333;
    }
  }
  &.upload {
    .images {
      height: calc(100% - 180px);
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  &.notUpload {
    .images {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  .images {
    /* display: flex;
    flex-wrap: wrap;
    gap: 10px; */
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    .more {
      background: #efefef;
      button {
        width: 100%;
        height: 100%;
        border: none;
        font-size: 30px;
        border-radius: 10px;
        svg {
          display: block;
          margin: auto;
        }
      }
    }
    &.gallery {
      li {
        width: calc(50% - 5px);
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
    li {
      width: calc(25% - 7.5px);
      overflow: hidden;
      display: inline-block;
      aspect-ratio: 1;
      cursor: pointer;
      position: relative;
      border-radius: 5px;
      border: 1px solid #ddd;
      overflow: hidden;
      margin-bottom: 10px;
      margin-right: 10px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.not {
        width: 100%;
        aspect-ratio: auto;
        color: #ccc;
        cursor: default;
        border: none;
      }
      p {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        display: flex;
        gap: 5px;
        padding: 2px 5px;

        span {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .context {
    z-index: 10;
    position: absolute;
    top: 50%;
    left: 50%;
    background: #fff;
    text-align: center;
    border-radius: 5px;
    width: 80px;
    border: 1px solid #ddd;
    transform: translate(-50%, -50%);
    li {
      padding: 3px 0;
      font-size: 12px;
      cursor: pointer;
      &:nth-child(2) {
        border-top: 1px solid #ddd;
      }
    }
  }
  .dragToUpload {
    margin: 20px 0;
    width: 100%;
    height: 100px;
    label {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 20px;
      width: 100%;
      border: 1px solid #aba9a9;
      border-radius: 5px;
      height: 100%;
    }
    i {
      font-size: 20px;
    }
  }
  .submit {
    width: 150px;
    height: 40px;
    border-radius: 10px;
    border: none;
    display: block;
    margin-left: auto;
    background: #0074ca;
    color: #fff;
    font-weight: 700;
  }
`;

export const DetailContainer = styled.div`
  flex-grow: 1;
  margin-bottom: 20px;
  min-height: 0;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ul {
    height: 100%;
    li {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 15px;
      &.eventMemo {
        align-items: flex-start;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .tit {
        text-align: center;
        width: 45px;
        font-weight: 700;
        .icon {
          svg {
            display: block;
            margin: auto;
            font-size: 22px;
            stroke-width: 0.5px;
          }
        }
        span {
          font-size: 12px;
        }
      }
      .cont {
        width: calc(100% - 55px);
      }
      .memo {
        .label {
          display: none;
        }
        ul {
          border: none;
          padding: 0;
        }
      }
    }
  }
`;

export const MembersContainer = styled.div`
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  .section {
    margin-bottom: 30px;
    p {
      font-size: 16px;
      font-weight: 800;
      margin-bottom: 20px;
    }
    &:last-child {
      margin-bottom: 0;
      flex-grow: 1;
      min-height: 0;
    }
  }
  ul {
    height: calc(100% - 40px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
  ul li,
  .manager {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
    }
    span {
      display: block;
      &.active {
        color: #0074ca;
      }
      &:first-child {
        font-size: 16px;
        margin-bottom: 5px;
        font-weight: 700;
      }
      &:last-child {
        font-size: 12px;
        color: #aba9a9;
      }
    }
  }
`;

export const DetailInfoContaienr = styled.div`
  &.dark {
    border-color: #333;
    .actions .context {
      border: 1px solid #333;
      background: #484848;
      li {
        border-bottom: 1px solid #333;
        &:hover {
          background: #333;
        }
      }
    }
  }
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #ddd;
  height: 70px;
  button {
    font-size: 24px;
    border: none;
    background: transparent;
    svg {
      display: block;
      margin: 0;
    }
  }
  span {
    font-size: 20px;
    font-weight: 700;
  }
  .actions {
    margin-left: auto;
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    .context {
      font-size: 14px;
      position: absolute;
      top: 25px;
      right: 0;
      z-index: 10;
      width: 80px;
      background: #fff;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      border-radius: 5px;
      border: 1px solid #ccc;
      overflow: hidden;
      li {
        text-align: center;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        transition: 0.3s;
        padding: 5px 0;
        &:last-child {
          border-bottom: none;
        }
        &:hover {
          background: #efefef;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    height: 50px;
    span {
      font-size: 16px;
    }
    button {
      font-size: 20px;
    }
  }
`;

export const ScheduleListContainer = styled.div`
  width: 260px;
  box-sizing: border-box;
  height: calc(100vh - 73px);
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  font-size: 12px;
  &.dark {
    .schedule li {
      &.event,
      &.holiday {
        background: #2b2b2b;
      }
    }
  }
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  .inner {
    width: 100%;
    height: 100%;
  }
  .date {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    span {
      &:first-child {
        font-weight: 700;
        display: inline-block;
        margin-right: 10px;
      }
    }
    div.weather {
      display: flex;
      align-items: center;
      svg {
        font-size: 17px;
      }
    }
  }
  .schedule {
    li {
      margin-bottom: 10px;
      padding: 15px;
      cursor: pointer;
      &.holiday {
        background: #efefef;
        .title {
          font-size: 14px;
        }
      }
      &.d-day {
        background: #333;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .info {
          font-size: 16px;
          max-width: 30%;
        }
        .title {
          max-width: 70%;
          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      &.event {
        background: #efefef;
        border-left: 5px solid;
        position: relative;
        .info {
          margin-top: 5px;
        }
        &.outside {
          &::after {
            content: "";
            width: 5px;
            height: 100%;
            background: #0074ca;
            background: linear-gradient(rgb(0, 116, 202), rgb(237, 85, 131));
            position: absolute;
            top: 0;
            left: 0;
            transform: translateX(-100%);
          }
        }
      }
      .title {
        font-size: 16px;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 5px;
        img {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .complete {
          text-decoration: line-through;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    &.dark {
      .inner {
        background: #2b2b2b;
      }
      .schedule li {
        &.holiday,
        &.event {
          background: #000;
        }
      }
    }
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    transition: 0.2s;
    .inner {
      padding: 20px;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 50%;
      overflow-y: auto;
      background: #fff;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px,
        rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px,
        rgba(0, 0, 0, 0.09) 0px -3px 5px;
      &::-webkit-scrollbar {
        width: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
`;

export const DownloadButton = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  gap: 10px;
  button {
    background: rgba(70, 151, 247, 0.8);
    width: 120px;
    height: 25px;
    border: none;
    font-size: 13px;
    border-radius: 3px;
    color: #fff;
  }
  i {
    width: 25px;
    height: 25px;
    cursor: pointer;
    position: relative;
    font-style: normal;
    span {
      width: 25px;
      height: 25px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      background: rgba(94, 94, 94, 0.9);
      color: #fff;
      border-radius: 50%;
    }
    &:hover {
      .tooltip {
        width: max-content;
        opacity: 1;
        padding: 10px;
      }
    }
  }
  .tooltip {
    transition: 0.3s;
    white-space: nowrap;
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    z-index: 9;
    color: #000;
    font-size: 12px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    opacity: 0;
    width: 0;
  }
  @media screen and (max-width: 767px) {
    i {
      display: none;
    }
  }
`;

export const SelectPrintContainer = styled.div`
  &.dark {
    .content {
      background: #000;
      ul li {
        label:hover {
          background: rgba(255, 255, 255, 0.25);
        }
        .more button {
          color: rgba(255, 255, 255, 0.5);
        }
      }
      > button {
        background: rgb(83, 59, 112);
      }
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 111;
  .content {
    z-index: 10;
    background: #fff;
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    width: 430px;
    height: 600px;
    max-width: 90vw;
    max-height: 80vh;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    > button {
      background: rgb(12, 65, 255);
      color: rgb(255, 255, 255);
      width: 100%;
      height: 30px;
      border-radius: 3px;
      border: none;
      margin-top: 30px;
    }
  }
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    span {
      font-size: 16px;
      font-weight: 700;
    }
    button {
      border: none;
      background: transparent;
      font-size: 20px;
      svg {
        display: block;
        margin: 0;
      }
    }
  }
  ul {
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    flex: 1;
    overflow-y: auto;
    li {
      label {
        display: block;
        width: 100%;
        padding: 5px;
        cursor: pointer;
        &:hover {
          background: #efefef;
        }
        input[type="checkbox"] {
          margin-right: 5px;
        }
      }
      &.personal {
        input[type="checkbox"] {
          accent-color: #139859;
        }
      }
      &.companyYnList {
        input[type="checkbox"] {
          accent-color: #0074ca;
        }
      }
      &.groupYnList {
        input[type="checkbox"] {
          accent-color: #f06f02;
        }
      }
      .more {
        button {
          border: none;
          background-color: transparent;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #333;
          padding: 5px 20px;
          width: 100%;
          span {
            font-size: 10px;
            svg {
              display: block;
              margin-left: 7px;
            }
          }
        }
        ul {
          max-height: 0;
          transition: 0.2s;
          overflow: hidden;
          li {
            label {
              padding-left: 20px;
              cursor: pointer;
            }
          }
          &.active {
            max-height: max-content;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
`;
